export enum NewsType {
    VISIT = "VISIT",
    RAID = "RAID",
    STEAL = 'STEAL'
}